import React from 'react';
import PropTypes from 'prop-types';
import Button from 'modules/common/Button';
import Footer from 'modules/partial/Footer';
import Privacy from './Privacy';
// import { getAuthUrl } from '../actions';

function ConcentPage({ partner }) {
  const [data] = React.useState({
    redirect_url: `${process.env.REACT_APP_END_POINT}/gamebox_subscriber/v1/oauth/redirect?partner_uuid=${partner.id}`,
  });
  // React.useEffect(() => {
  //   getAuthUrl(partner.id, (res) => {
  //     if (partner.is_white_labeled) {
  //       window.location.href = res?.redirect_url;
  //       return;
  //     }
  //     setData(res);
  //   });
  // }, [partner, setData]);

  const [isLoading, setIsLoading] = React.useState(false);
  const handleLogin = () => {
    setIsLoading(true);
    window.location.href = data.redirect_url;
  };
  const [showTerms, setShowTerms] = React.useState(false);
  const handleViewTerms = (e) => {
    e.preventDefault();
    setShowTerms(true);
  };
  return (
    <>
      {showTerms ? (
        <div className="bg-gray-50 mt-auto p-6 rounded-t-3xl shadow relative z-20">
          <div className="mb-6">
            <Privacy />
          </div>
          <Button
            className="w-full"
            type="button"
            onClick={() => setShowTerms(false)}
          >
            Close
          </Button>
        </div>
      ) : (
        <div className="bg-gray-50 mt-auto p-6 rounded-t-3xl shadow relative z-20 space-y-8">
          <div className="text-xs text-center text-gray-700 uppercase">
            Login to your {partner?.account_label}.
          </div>
          <div className="flex items-center justify-center">
            <img
              className="w-64 h-24 object-contain object-center"
              src={partner?.account_logo}
              alt="auth provider"
            />
          </div>
          <div className="space-y-8 ">
            <div className="text-sm">
              By clicking continue, you confirm that you read the{' '}
              <a
                className="text-primary-500 underline"
                href="/"
                onClick={handleViewTerms}
              >
                Terms and Conditions
              </a>{' '}
              and agree to the{' '}
              <a
                className="text-primary-500 underline"
                href="/"
                onClick={handleViewTerms}
              >
                Privacy Notice
              </a>
            </div>
            {partner?.status === 'DEACTIVATED' && (
              <Button className="w-full" danger>
                Under Maintenance
              </Button>
            )}
            {partner?.status !== 'DEACTIVATED' && (
              <>
                {data?.error || !data ? (
                  <Button className="w-full" type="button" primary disabled>
                    {data?.data?.message || 'Authentication failed'}
                  </Button>
                ) : (
                  <Button
                    className="w-full"
                    type="button"
                    primary
                    onClick={handleLogin}
                    disabled={isLoading}
                  >
                    {isLoading ? 'Please wait...' : 'Continue'}
                  </Button>
                )}
              </>
            )}
          </div>
          {!partner?.is_white_labeled ? <Footer /> : null}
        </div>
      )}
      <div
        className="pointer-events-none absolute z-10 h-full w-full inset-0 top-0 left-0 bg-gray-500 bg-center bg-no-repeat bg-cover"
        style={{ backgroundImage: `url(${partner.bg_login_url})` }}
      >
        &nbsp;
      </div>
    </>
  );
}

ConcentPage.propTypes = {
  partner: PropTypes.instanceOf(Object).isRequired,
};

export default ConcentPage;
